import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateRowRange } from '@/redux/slices/payoutStructure';
import styles from '../payout-structures.module.css';
import TableCellRangeInput from './TableCellRangeInput';
import classNames from 'classnames';

interface RowHeaderProps {
  rowIndex: number;
}

const RowHeader: React.FC<RowHeaderProps> = ({ rowIndex }) => {
  const dispatch = useDispatch();

  const row = useSelector((state: any) => state.payoutStructure.rankRows[rowIndex]);
  const rankRows = useSelector((state: any) => state.payoutStructure.rankRows);

  const rowFrom = row?.rankFrom || 1;
  const rowTo = row?.rankTo || 1;

  const rowValid = useMemo(() => {
    const previousRow = rankRows[rowIndex - 1];
    const isLowerThanPrevious = previousRow && rowFrom <= previousRow.rankTo;

    const nextRow = rankRows[rowIndex + 1];
    const isHigherThanNext = nextRow && rowTo >= nextRow.rankFrom;

    return !isLowerThanPrevious && !isHigherThanNext;
  }, [rowFrom, rowTo, rankRows, rowIndex]);

  const handleChange = (value: { from: number; to: number }) => {
    const fromValue = value.from === 0 ? 1 : value.from;
    const toValue = value.to === 0 ? 1 : value.to;

    dispatch(
      updateRowRange({
        index: rowIndex,
        rankFrom: fromValue,
        rankTo: toValue,
      }),
    );
  };

  return (
    <div className={classNames(styles.payoutStructureTableHeaderCellContainer)}>
      <TableCellRangeInput
        min={1}
        invalid={!rowValid}
        onFocus={(e) => {
          e.target.select();
          e.target.focus();
        }}
        onChange={handleChange}
        value={{
          from: rowFrom,
          to: rowTo,
        }}
      />
    </div>
  );
};

export default RowHeader;
